// extracted by mini-css-extract-plugin
export default {"wrapper":"ReCaptcha_wrapper--OG9"};